var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesHomeBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 676,
    viewBox: "0 0 638 676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4506_52740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.045 266.551C509.045 372.581 329.136 517.362 223.106 517.362C117.076 517.362 84.8223 388.712 84.8223 282.682C84.8223 176.651 139.014 216.461 245.044 216.461C351.074 216.461 509.045 160.52 509.045 266.551Z",
    fill: "#7724FF",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4506_52740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.242 156.4C561.506 256.036 559.418 374.008 459.782 410.273C360.146 446.537 175.044 312.261 138.779 212.625C102.515 112.989 249.407 163.382 349.043 127.118C448.678 90.8532 488.977 56.7641 525.242 156.4Z",
    fill: "#332FFF",
    fillOpacity: 0.18
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4506_52740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 371.072,
    cy: 410.195,
    r: 142.636,
    fill: "#2FA7FF",
    fillOpacity: 0.18
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4506_52740",
    x: 0.234673,
    y: 117.127,
    width: 593.398,
    height: 484.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.2938,
    result: "effect1_foregroundBlur_4506_52740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4506_52740",
    x: 43.0662,
    y: 0.699982,
    width: 593.76,
    height: 505.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.0401,
    result: "effect1_foregroundBlur_4506_52740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4506_52740",
    x: 105.4,
    y: 144.523,
    width: 531.345,
    height: 531.345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 61.5182,
    result: "effect1_foregroundBlur_4506_52740"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesHomeBg);
export default __webpack_public_path__ + "static/media/sales-home-bg.d16efeacc5dfb66910cdc4866dfac2d9.svg";
export { ForwardRef as ReactComponent };